export const PROTOCOL_SETTINGS = 'protocolSettings';
export const SMART_SETTINGS = 'smartSettings';
